import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["borderRadius", "display", "height", "opacity", "shimmerColor", "width", "children"],
  _excluded2 = ["borderBottomLeftRadius", "borderBottomRightRadius", "color", "height", "width"];
import { keyframes } from 'styled-components';
import styled from 'foundations-theming/utils';
import { rgba } from 'foundations-components/transitional/utils/color';
import { filterTokenProps } from 'foundations-components/utils/filterTokenProps';
import { useMapTokenPropsToCSS } from 'foundations-components/hooks/useMapTokenPropsToCSS';
import { jsx as _jsx } from "react/jsx-runtime";
const shimmerAnimation = keyframes(["0%{left:-50%;}100%{left:100%;}"]);
const SkeletonWrapperStyled = styled.div.withConfig({
  displayName: "Skeleton__SkeletonWrapperStyled"
})(["overflow:hidden;position:relative;border-radius:", ";height:", ";width:", ";display:", ";opacity:", ";", " &::before{z-index:1;content:'';display:block;position:absolute;width:50%;height:100%;top:0;left:-50%;animation:", " 1s cubic-bezier(0.42,0,0.58,1) infinite;background:linear-gradient( to right,transparent 0%,", " 50%,transparent 100% );}"], ({
  $borderRadius,
  theme
}) => $borderRadius ? theme.borderRadius[$borderRadius] : undefined, ({
  $height
}) => typeof $height === 'number' ? `${$height}px` : $height, ({
  $width
}) => typeof $width === 'number' ? `${$width}px` : $width, ({
  $display
}) => $display, ({
  $opacity
}) => $opacity, ({
  $tokenCssStyles
}) => $tokenCssStyles, shimmerAnimation, ({
  $shimmerColor,
  theme
}) => $shimmerColor ? rgba(theme.color[$shimmerColor], 0.65) : rgba(theme.color['fill-surface-default'], 0.65));
export const SkeletonWrapper = _ref => {
  let {
      borderRadius,
      display,
      height,
      opacity,
      shimmerColor,
      width,
      children
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    tokenProps
  } = filterTokenProps(props);
  const tokenCssStyles = useMapTokenPropsToCSS(tokenProps);
  return (
    /*#__PURE__*/
    // @bend-expect trellis-tokenized
    _jsx(SkeletonWrapperStyled, {
      $borderRadius: borderRadius,
      $display: display,
      $height: height,
      $opacity: opacity,
      $shimmerColor: shimmerColor,
      $tokenCssStyles: tokenCssStyles,
      $width: width,
      children: children
    })
  );
};
const SkeletonBlockStyled = styled.div.withConfig({
  displayName: "Skeleton__SkeletonBlockStyled"
})(({
  $borderBottomLeftRadius,
  $borderBottomRightRadius,
  $color = 'fill-accent-neutral-subtle-alt',
  $height,
  $width,
  $tokenCssStyles,
  theme
}) => {
  return Object.assign({
    backgroundColor: theme.color[$color]
  }, $borderBottomLeftRadius && {
    borderBottomLeftRadius: theme.borderRadius[$borderBottomLeftRadius]
  }, $borderBottomRightRadius && {
    borderBottomRightRadius: theme.borderRadius[$borderBottomRightRadius]
  }, {
    height: $height,
    width: $width
  }, $tokenCssStyles);
});
export const SkeletonBlock = _ref2 => {
  let {
      borderBottomLeftRadius,
      borderBottomRightRadius,
      color,
      height,
      width
    } = _ref2,
    props = _objectWithoutPropertiesLoose(_ref2, _excluded2);
  const {
    tokenProps
  } = filterTokenProps(props);
  const tokenCssStyles = useMapTokenPropsToCSS(tokenProps);
  return (
    /*#__PURE__*/
    // @bend-expect trellis-tokenized
    _jsx(SkeletonBlockStyled, {
      $borderBottomLeftRadius: borderBottomLeftRadius,
      $borderBottomRightRadius: borderBottomRightRadius,
      $color: color,
      $height: height,
      $tokenCssStyles: tokenCssStyles,
      $width: width
    })
  );
};